/**
 * Created by yniran on 12/14/14.
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        template = require("connection-templates/ticketTab/ticketListView.tmpl"),
        emptySearchViewTemplate = require("connection-templates/ticketTab/ticketListEmptySearchView.tmpl"),
        emptyViewTemplate = require("connection-templates/ticketTab/ticketListEmptyView.tmpl"),
        TicketListItemView = require("connection-views/ticketTab/TicketListItemView"),
        TicketsListEmptyView = require("connection-views/ticketTab/TicketsListEmptyView"),
        TicketsListView = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        TicketsListView = Marionette.CompositeView.extend({
            template: template,
            className: 'ticket-list-wrapper',
            itemViewContainer: ".ticket-list-container",
            itemView: TicketListItemView,

            setSelected: function (id) {
                this.children.each(function (view) {
                    if(view.setSelected){
                        view.setSelected(id);
                    }
                });
            },

            getEmptyView:function(){
                if(this.collection.hasNoTickets){
                    return Marionette.ItemView.extend({
                        template: emptyViewTemplate,
                        className: 'no-results-view'
                    });
                }else{
                    return Marionette.ItemView.extend({
                        template: emptySearchViewTemplate,
                        className: 'no-results-view'
                    });
                }
            }

        });
});
    return TicketsListView;
});
